import React from "react";
import { Flame, Loader2, RefreshCw } from "lucide-react";
import Select, { SingleValue } from "react-select";
import { useForneiro } from "../context/ForneiroContext";
import FornoColuna from "./FornoColuna";

const ForneiroContent: React.FC = () => {
  const {
    items,
    colunas,
    loading,
    refreshing,
    finalizandoId,
    tick,
    refreshNow,
    handleFinalizar,
    handleMover,
    canFinalizar,
    showLojaSelector,
    lojaOptions,
    selectedLojaId,
    setSelectedLojaId,
  } = useForneiro();

  if (loading) {
    return (
      <main className="flex h-[calc(100vh-4rem)] items-center justify-center">
        <Loader2 size={32} className="animate-spin text-orange-500" />
      </main>
    );
  }

  return (
    <main className="flex h-[calc(100vh-4rem)] flex-col">
      <div className="flex items-center justify-between border-b border-neutral-200 bg-white px-4 py-3">
        <div className="flex items-center gap-2">
          <Flame size={20} className="text-orange-500" />
          <h1 className="text-lg font-bold text-neutral-800">Fila do Forno</h1>
          <span className="rounded-full bg-orange-100 px-2.5 py-0.5 text-xs font-semibold text-orange-700">
            {items.length} {items.length === 1 ? "item" : "itens"}
          </span>
        </div>
        <div className="flex items-center gap-3">
          {showLojaSelector && (
            <div className="w-56">
              <Select
                inputId="forno-loja-select"
                value={
                  selectedLojaId
                    ? (lojaOptions.find((o) => o.value === selectedLojaId) ??
                      null)
                    : null
                }
                onChange={(
                  opt: SingleValue<{ value: number; label: string }>
                ) => setSelectedLojaId(opt?.value)}
                options={lojaOptions}
                isClearable
                placeholder="Todas as lojas"
              />
            </div>
          )}
          <button
            onClick={refreshNow}
            disabled={refreshing}
            className="flex items-center gap-1.5 rounded-lg border border-neutral-300 px-3 py-2 text-sm text-neutral-600 transition-colors hover:bg-neutral-100 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {refreshing ? (
              <>
                <Loader2 size={14} className="animate-spin" />
                Atualizando...
              </>
            ) : (
              <>
                <RefreshCw size={14} />
                Atualizar
              </>
            )}
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-x-auto overflow-y-hidden">
        {colunas.length === 0 ? (
          <div className="flex h-full flex-col items-center justify-center text-neutral-400">
            <Flame size={48} className="mb-3 opacity-30" />
            <p className="text-lg font-medium">Nenhum item na fila</p>
            <p className="text-sm">
              Os itens aparecerão aqui quando o pizzaiolo finalizar a montagem
            </p>
          </div>
        ) : (
          <div className="flex h-full gap-4 p-4">
            {colunas.map((colunaItems, idx) => (
              <FornoColuna
                key={idx}
                items={colunaItems}
                colunaIndex={idx}
                totalColunas={colunas.length}
                tick={tick}
                finalizandoId={finalizandoId}
                canFinalizar={canFinalizar}
                onFinalizar={handleFinalizar}
                onMover={handleMover}
              />
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default ForneiroContent;
